import { render, staticRenderFns } from "./assetesCascader.vue?vue&type=template&id=d9960246"
import script from "./assetesCascader.vue?vue&type=script&lang=js"
export * from "./assetesCascader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports